import { Controller } from '@hotwired/stimulus'

function formatMoney(cents) {
  if (!cents) return '—'
  return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export default class extends Controller {
  static values = { url: String }
  static targets = ['dialog', 'title', 'count', 'body', 'copyBtn']

  open({ params: { id, name } }) {
    this.titleTarget.textContent = name || '—'
    this.countTarget.textContent = ''
    this.bodyTarget.innerHTML = `
      <tr>
        <td colspan="5" class="px-6 py-16 text-center">
          <svg class="mx-auto h-5 w-5 animate-spin text-zinc-400" viewBox="0 0 24 24" fill="none">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
        </td>
      </tr>`
    this._resetCopyBtn()
    this.dialogTarget.showModal()

    const searchParams = new URLSearchParams(window.location.search)
    const range = searchParams.get('range') || '30d'
    let url = `${this.urlValue}?campaign_id=${encodeURIComponent(id)}&range=${encodeURIComponent(range)}`
    if (range === 'custom') {
      const startDate = searchParams.get('start_date')
      const endDate = searchParams.get('end_date')
      if (startDate) url += `&start_date=${encodeURIComponent(startDate)}`
      if (endDate) url += `&end_date=${encodeURIComponent(endDate)}`
    }

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(rows => {
        this._rows = rows
        this.countTarget.textContent = `${rows.length} order${rows.length !== 1 ? 's' : ''}`

        if (rows.length === 0) {
          this.bodyTarget.innerHTML = `
            <tr>
              <td colspan="5" class="px-6 py-16 text-center font-mono text-sm text-zinc-500">—</td>
            </tr>`
          return
        }

        this.bodyTarget.innerHTML = rows.map(row => `
          <tr class="hover:bg-zinc-50">
            <td class="px-6 py-3 text-sm font-medium text-zinc-900">${this._esc(row.number) || '—'}</td>
            <td class="px-6 py-3 text-sm text-zinc-700">${this._esc(row.email) || '—'}</td>
            <td class="px-6 py-3 text-right text-sm text-zinc-900 tabular-nums">${formatMoney(row.amount_cents)}</td>
            <td class="px-6 py-3 text-sm">
              <span class="inline-flex items-center rounded-full border border-zinc-200 bg-white px-2.5 py-0.5 text-xs font-medium text-zinc-700">
                ${this._esc((row.match_method || '').replace(/_/g, ' '))}
              </span>
            </td>
            <td class="px-6 py-3 text-right text-sm text-zinc-500 tabular-nums">${this._esc(row.date) || '—'}</td>
          </tr>`).join('')
      })
  }

  close() {
    this.dialogTarget.close()
  }

  copy() {
    if (!this._rows || this._rows.length === 0) return

    const header = 'Order,Email,Amount,Method,Date'
    const lines = this._rows.map(r => {
      const amount = r.amount_cents ? formatMoney(r.amount_cents) : '—'
      return [r.number || '', r.email || '', amount, r.match_method || '', r.date || ''].join(',')
    })
    const csv = [header, ...lines].join('\n')

    navigator.clipboard.writeText(csv).then(() => {
      this.copyBtnTarget.textContent = 'Copied'
      setTimeout(() => this._resetCopyBtn(), 2000)
    })
  }

  _resetCopyBtn() {
    this.copyBtnTarget.textContent = 'Copy CSV'
  }

  _esc(str) {
    if (!str) return ''
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
  }
}
